export enum ActionTypes {
  // dashboard action
  SET_THEME = "SET_THEME",

  // user action
  SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN",
  SET_USER_INFO = "SET_USER_INFO",
  DELETE_USER = "DELETE_USER",
  SET_USER_ACCESS = "SET_USER_ACCESS"
}
